import React from "react";
import { ToastContainer } from "react-toastify";

import SettingsEventsDetails from "./components/SettingsEventsDetails";

const SettingsEventsDetailsApp = (props) => {
  return (
    <>
      <ToastContainer icon={false} />
      <SettingsEventsDetails {...props} />
    </>
  );
};

export default SettingsEventsDetailsApp;
